// cart-cross-sell-ajax.js
// Unified BYB + cart cross-sell logic
// ----------------------------------------------------

(function () {
  console.log("🔥 BYB: Unified cart script loaded");

  if (window.BYB_UNIFIED_CART_INIT) {
    console.log("ℹ️ BYB: Unified cart script already initialized, skipping");
    return;
  }
  window.BYB_UNIFIED_CART_INIT = true;

  // -------------------------------
  // 1. Neutralize Shopify hijacks
  // -------------------------------
  try {
    if (
      window.fetch &&
      typeof window.fetch === "function" &&
      window.fetch.toString().includes("shop_events_listener")
    ) {
      console.log("🛑 BYB: Neutralizing Shopify fetch override");
      window.originalFetch = window.fetch;
      window.fetch = window.fetch.bind(window);
    }
  } catch (e) {
    console.warn("BYB: Failed to neutralize fetch override", e);
  }

  const nativeFetch = window.originalFetch || window.fetch.bind(window);

  // -------------------------------
  // 2. Refresh logic
  // -------------------------------

  async function refreshDrawerInner() {
    try {
      if (!customElements.get("drawer-inner"))
        await customElements.whenDefined("drawer-inner");
    } catch (e) {}

    const drawerInner = document.querySelector("cart-drawer drawer-inner");

    if (drawerInner && typeof drawerInner.requestRender === "function") {
      console.log("🔄 BYB: drawer-inner.requestRender()");
      await drawerInner.requestRender();
      return true;
    }

    console.warn("🟥 BYB: drawer-inner.requestRender() not available");
    return false;
  }

  async function refreshDrawerSection() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) {
      console.warn("🟥 BYB: No <cart-drawer> found!");
      return;
    }

    // ⭐ THIS IS THE FIX ⭐
    const sectionId = drawer.dataset.sectionId; // e.g. "sections--2029xxxx__cart-drawer"
    console.log("🟦 BYB Using dynamic section ID:", sectionId);

    const url = `/?sections=${sectionId},header`;
    const res = await nativeFetch(url);
    const json = await res.json();

    const parser = new DOMParser();

    // --- Update Drawer ---
    const drawerHTML = json[sectionId];
    if (drawerHTML) {
      const doc = parser.parseFromString(drawerHTML, "text/html");
      const newDrawer = doc.querySelector("cart-drawer");
      const liveDrawer = document.querySelector("cart-drawer");

      if (newDrawer && liveDrawer) {
        console.log("♻️ BYB: Replacing <cart-drawer> innerHTML");
        liveDrawer.innerHTML = newDrawer.innerHTML;
        window.dispatchEvent(new Event("fluco:modal:cartDrawer:open"));
      }
    }

    // --- Update Header ---
    const headerHTML = json["header"];
    if (headerHTML) {
      const doc2 = parser.parseFromString(headerHTML, "text/html");
      const newHeader = doc2.querySelector("header");
      const liveHeader = document.querySelector("header");

      if (newHeader && liveHeader) {
        console.log("♻️ BYB: Updating header");
        liveHeader.replaceWith(newHeader);
      }
    }
  }

  async function refreshCartUI() {
    const ok = await refreshDrawerInner();
    if (!ok) await refreshDrawerSection();
  }

  // -------------------------------
  // 3. BYB form handler
  // -------------------------------

  async function handleBYBFormSubmit(event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute("action") !== "/cart/add") return;

    event.preventDefault();

    const formData = new FormData(form);
    const variantId = formData.get("id");
    console.log("🔥 BYB: Adding variant", variantId);

    const submitBtn = form.querySelector("button[type='submit']");
    if (submitBtn) submitBtn.disabled = true;

    try {
      const resp = await nativeFetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      });

      if (!resp.ok) return;

      window.dispatchEvent(new Event("fluco:modal:cartDrawer:open"));
      await refreshCartUI();
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  document.addEventListener("submit", handleBYBFormSubmit, true);

  // -------------------------------
  // 4. Cross-sell button handler
  // -------------------------------

  document.addEventListener("click", async (event) => {
    const btn = event.target.closest(".cross-sells-item__add-button");
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = btn.dataset.variantId;
    btn.disabled = true;

    try {
      const resp = await nativeFetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!resp.ok) return;

      window.dispatchEvent(new Event("fluco:modal:cartDrawer:open"));
      await refreshCartUI();
    } finally {
      btn.disabled = false;
    }
  });

  console.log("✅ BYB Unified script initialized");
})();
